import React, { useState } from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import { useMandatorContext } from "@bn/theming";

export const MandatorsSlugSelect = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const { mandatorSlug, mandatorsList, setLocalMandatorSlug } =
    useMandatorContext();

  if (
    !["staging", "development", "sandbox", "e2e", "preview"].includes(
      import.meta.env.VITE_APP_ENVIRONMENT ?? ""
    )
  )
    return null;

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Box
        onClick={(e) => setAnchorEl(e.currentTarget)}
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          cursor: "pointer",
          background: (theme) => theme.palette.background.default,
          borderRadius: "50%",
          width: "40px",
          height: "40px",
        }}
      >
        {mandatorSlug?.slice(0, 3)}
      </Box>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        keepMounted
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {mandatorsList.map((mandator) => (
          <MenuItem
            key={mandator}
            value={mandator}
            onClick={() => {
              setLocalMandatorSlug(mandator);
              setAnchorEl(null);
            }}
            selected={mandator === mandatorSlug}
          >
            {mandator}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
